import { useState, useEffect } from 'react';
import { extractDomain } from './popupUtils';

export const useSearch = (allAliases, url, lookupExistingAliases) => {
    const [search, setSearch] = useState('');
    const [searchTimer, setSearchTimer] = useState(null);

    useEffect(() => {
        return () => {
            if (searchTimer) {
                clearTimeout(searchTimer);
            }
        };
    }, [searchTimer]);

    const handleSearch = async (searchTerm) => {
        setSearch(searchTerm);
        
        if (searchTimer) {
            clearTimeout(searchTimer);
        }
        
        if (searchTerm === '') {
            // Clear search - show domain-filtered results
            const domain = extractDomain(url);
            const matchingAliases = allAliases.filter(alias => 
                alias.site_url && (
                    alias.site_url.includes(domain) || 
                    alias.site_url.includes(url)
                )
            );
            return matchingAliases;
        } else {
            // Debounced search
            const timer = setTimeout(() => {
                lookupExistingAliases(url, searchTerm);
            }, 500);
            setSearchTimer(timer);
            return null; // Will be handled by lookupExistingAliases
        }
    };

    const clearSearch = () => {
        setSearch('');
        const domain = extractDomain(url);
        const matchingAliases = allAliases.filter(alias => 
            alias.site_url && (
                alias.site_url.includes(domain) || 
                alias.site_url.includes(url)
            )
        );
        return matchingAliases;
    };

    return {
        search,
        handleSearch,
        clearSearch
    };
};